import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { BaseFormGroup } from 'src/app/shared/form-input-components/base-form-group';

@Component({
  selector: 'app-vendor-select',
  templateUrl: './vendor-select.component.html',
  styleUrls: ['./vendor-select.component.scss']
})
export class VendorSelectComponent extends BaseFormGroup implements OnInit {

  @Input() vendors: any;
  @Input() isGlobal: boolean;
  @Input() selectedBookings: any;
  @Input() vendorSelectConfigObj: any;
  @Input() vendorFormControl: any;
  @Input() booking: any;
  @Input() elementType: any;
  @Input() label: string;

  @Output() vendorSelectedValidationsCallback = new EventEmitter();
  @Output() globalVendorSelectedCallback = new EventEmitter();

  constructor() {
    super();
   }

  ngOnInit() {
  }

  getVendorValue(vendor: any) {
    if (vendor) {
    return vendor.guid;
    }
  }

  getVendorLabel(vendor: any) {
    if (vendor) {
    return vendor.vendorName;
    }
  }

  onVendorSelected(vendorGuid: any) {
    if (this.isGlobal && this.globalVendorSelectedCallback) {
      this.globalVendorSelectedCallback.emit(vendorGuid);
    }
    if (this.vendorSelectedValidationsCallback) {
      this.vendorSelectedValidationsCallback.emit(this.booking);
    }
  }

}
